import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import { panelModule } from './modules/panel';
import { catalogPromptLifecycleModule } from './components/catalog/promptLifecycleModule';

export default createApp({
  features: [catalogPlugin, navModule, authModule, panelModule, catalogPromptLifecycleModule],
});
